module.exports = __webpack_public_path__ + "static/media/1.ff7efd75.png";